<template>
    <div>
        <div class="row" v-if="data != null">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-info">
                        <h4 class="card-title ">Pelanggan Admin Belum Bayar</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class=" text-info">
                                    <th>No.</th>
                                    <th>Nama</th>
                                    <th>PPOE</th>
                                    <th>Paket</th>
                                    <th>Area</th>
                                    <th>Biaya</th>
                                    <th>Tgl Register</th>
                                    <th></th>
                                </thead>
                                <tbody>
                                <tr v-for="(u, index) in detail.form.data">
                                    <td>{{ index+1 }}</td>
                                    <td><strong>{{ u.user.unama }}</strong></br>{{ u.user.wa }}</td>
                                    <td><span class="text-info">{{ u.user.ppoe }}</span></td>
                                    <td>{{ u.user.pnama }}</br>Tagihan Tgl {{ u.user.tanggal_tagihan }}</td>
                                    <td>{{ u.area }}</td>
                                    <td>
                                    {{ ribu( ( ( parseInt(u.user.ptarif) + parseInt(detail.isNull(u.user.biaya_tambahan)) + parseInt(detail.isNull(u.user.biaya_tambahan_2)) ) + (  ( (parseInt(u.user.ptarif) + parseInt(detail.isNull(u.user.biaya_tambahan)) + parseInt(detail.isNull(u.user.biaya_tambahan_2)) ) / 100 ) ) * parseInt(data.ppn)   ) - parseInt(detail.isNull(u.user.diskon)) ) }} <i class="tombol material-icons text-info" @mouseover="data.infoShow = index" @mouseleave="data.infoShow = -1">error</i> 
                                    <span class="info" v-if="data.infoShow == index" v-show="data.infoShow == index">
                                        <p class="mb-0">PPN {{data.ppn}}% : {{ribu(parseInt(data.ppn) * ( parseInt(u.user.ptarif) / 100 ) )}}</p>
                                        <p class="mb-0">{{u.user.biaya_rincian}} : {{ribu(u.user.biaya_tambahan) }}</p>
                                        <p class="mb-0">{{u.user.biaya_rincian_2}} : {{ribu(u.user.biaya_tambahan_2) }}</p>
                                        <p class="mb-0">Diskon : {{ribu(u.user.diskon) }}</p>
                                    </span>
                                    </td>
                                    <td>{{ tglIndo(u.user.tanggal_register) }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
	components: { 

	}, 
  setup() {
    const data = reactive({
        area: [],
        username: '',
        id: '',
        ppn: '',
        infoShow: null
    })
    const detail = {
      form : reactive({
        data: [],
        alert: null,
        alertSuccess: null
      }),
        isNull(x) {
        var a;
        if (x == null) {
            a = 0;
        } else {
            a = x
        }
        return a;
        },
      get() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            id: data.id,
            bulan: sessionStorage.getItem('bulanIdBase'),
            tahun: sessionStorage.getItem('tahunBase')
        }
        
        var apiUrl = inter.AdminDetailPelangganBelum();
        myGlobal.call(datax,apiUrl).then(x => {
            //myGlobal.loger(x);
            if (x.status == true) {
                this.form.data = x.data;
            } else {
            //alert(x.pesan);
            }
        })
      }
    }
    return {
      data,
      myGlobal,
      detail
    }
  },
  mounted () {
    document.title = "Rincian Admin";

    this.data.ppn = myGlobal.PPN();
    this.data.id = this.$route.params.id;

    this.detail.get();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.info {
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  z-index: 999999999;
  margin-top: -50px;
}
.tombol {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/detail/pelanggan-belum.vue